// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"271":"8f7bec60","274":"9dbffda3","453":"d855a71b","460":"a29b1d73","523":"4d351adc"}[chunkId] + ".chunk.js";
};